module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/apple-icon-120x120-b6bcdab2098bd81177c6986a67d19827.png";